import React, {Component} from "react";

import { connect } from "react-redux";
import { updateForm, setPage } from "../../../store/actions/FormAction";
/*
    Importing Notice for dismissable alerts
*/
import Notice from "./partials/Notice";
import InDefault from "./partials/InDefault";
import Active from "./partials/Active";
/*
    Importing different screens based on different statuses
*/
import StatusBar from "./partials/StatusBar";
import QualifiedCongrats from "./partials/QualifiedCongrats";
import FastTrackCopy from "./partials/FastTrackCopy";
import LoanInformation from "./partials/LoanInformation";

/*
    Dashboard view that displays the Dashboard pages
    Remember JSX requires you to use camelcasing of attributes
    (ie className vs 'class', htmlFor vs 'for', tabIndex vs tab-index)
    Remember JSX requires all tags be closed (ie: self closed <hr />, <br />)
    Create React App requires alt tags for all <img> elements (good for SEO too)
*/

class MyAccount extends Component {
  componentDidMount() {
    this.props.updateForm("pagename", "Account");
    this.props.setPage("myaccount");
    //For Testing Purposes
    if (this.props.st.length < 1){
      this.props.updateForm("fn", "John");
      this.props.updateForm("ln", "Doe");
      this.props.updateForm("address", "123 Main St, Columbus, OH, 34567");
      this.props.updateForm("street", "123 Main St");
      this.props.updateForm("city", "Columbus");
      this.props.updateForm("st", "Ohio");
      this.props.updateForm("stt", "OH");
      this.props.updateForm("zip", "34567");
      this.props.updateForm("eml", "jonathandoe@johndoeacct.com");
      this.props.updateForm("phn", "512-321-4567");
      this.props.updateForm("ismobile", true);
      this.props.updateForm("ssn", "XXX-XX-1234");
      this.props.updateForm("co", "ABCD Co");
      this.props.updateForm("cophn", "412-321-4567");
      this.props.updateForm("payfrequency", "Bi-Weekly");
      this.props.updateForm("payamount", "1643.56");
      this.props.updateForm("accounttype", "Checking");
      this.props.updateForm("bankaccount", "81214654564");
      this.props.updateForm("routingnum", "012100564");
      this.props.updateForm("sig1", "1234");
      this.props.updateForm("sig2", "1234");
      this.props.updateForm("sig3", "1234");
      this.props.updateForm("ref1fn", "Mary");
      this.props.updateForm("ref1ln", "Doe");
      this.props.updateForm("ref1phn", "512-321-4567");
      this.props.updateForm("ref1rel", "Sister");
      this.props.updateForm("ref2fn", "Jenny");
      this.props.updateForm("ref2ln", "Appleseed");
      this.props.updateForm("ref2phn", "312-555-4863");
      this.props.updateForm("ref2rel", "Cousin");
    }

  }

  render() {
    return (
      <div id="dashboard1">
        <div className="dashheader">
          {this.props.pagename}
        </div>
        { this.props.indefault && <InDefault /> }

        { !this.props.noticedismissed && <Notice /> }

        { this.props.originatedmsg && <Active /> }

        <div className="dashmain">

          <StatusBar />

          <QualifiedCongrats/>

          <FastTrackCopy/>

          <LoanInformation/>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
    page: state.FormReducer.page,
    pagename: state.FormReducer.pagename,
    indefault: state.FormReducer.indefault,
    eligible: state.FormReducer.eligible,
    status: state.FormReducer.status,
    loanamt: state.FormReducer.loanamt,
    st: state.FormReducer.st,
    accountnumber: state.FormReducer.accountnumber,
    noticedismissed: state.FormReducer.noticedismissed,
    originatedmsg: state.FormReducer.originatedmsg
});

const mapDispatchToProps = (dispatch) => ({
    updateForm: (stateType, value) => dispatch(updateForm(stateType, value)),
    setPage: (page) => dispatch(setPage(page))
});

export default connect(mapStateToProps, mapDispatchToProps)(MyAccount);



// WEBPACK FOOTER //
// ./src/components/views/Dashboard/MyAccount.js